/**
 * Pay now flow error codes.
 */
export enum PaynowErrorCode {
  COLLECT_PAYMENT_FAILED = 'error.paynow.collect_payment.failed',
  DATA_LOAD_FAILED = 'error.paynow.data_load.failed',
}
